var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafelockKeySoftware(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Safelock_key_software"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Safelock_key_software",
    "data-name": "Safelock key software",
    clipPath: "url(#clip-Safelock_key_software)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop-security_12422002",
    transform: "translate(-2 -1.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M86.343,15.978H79.687a30.29,30.29,0,0,1,1.088,8.128h3.952V68.09H14.439V24.106h3.936a30.29,30.29,0,0,1,1.088-8.128H12.807a6.5,6.5,0,0,0-6.5,6.5V76.218H92.855V22.474a6.5,6.5,0,0,0-6.512-6.5Z",
    transform: "translate(2.425 7.154)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M102,56.579A12.742,12.742,0,0,1,89.264,69.331H14.752A12.756,12.756,0,0,1,2,56.579H39.968l1.68,4.3a3.244,3.244,0,0,0,3.024,2.064H59.328a3.228,3.228,0,0,0,3.024-2.064l1.68-4.3Z",
    transform: "translate(0 29.992)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M44.08,3.26a28,28,0,1,0,28,28,28,28,0,0,0-28-28Zm4.3,30.56L49.824,41a1.262,1.262,0,0,1-1.232,1.52H39.584A1.273,1.273,0,0,1,38.336,41l1.456-7.216a1.212,1.212,0,0,0-.448-1.184,7.2,7.2,0,0,1,4.768-12.624,7.4,7.4,0,0,1,7.168,7.584,7.161,7.161,0,0,1-2.432,5.008,1.309,1.309,0,0,0-.464,1.248Z",
    transform: "translate(7.92)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafelockKeySoftware);
export default __webpack_public_path__ + "static/media/safelock-key-software.00ce586c1b74876a7fe72ace600416ea.svg";
export { ForwardRef as ReactComponent };